export const navLinks = [
  { name: '首页', path: '/', icon: 'ri-home-line' },
  { name: '分类', path: '/category/all', icon: 'ri-grid-line' },
  { name: '排行榜', path: '/category/all?sort=hot', icon: 'ri-fire-line' },
  { name: '最新', path: '/category/all?sort=new', icon: 'ri-timer-flash-line' },
  { name: '关于我们', path: '/about', icon: 'ri-information-line' },
];

export const siteInfo = {
  name: '果冻传媒',
  tagline: '高清全集免费播放，随时随地畅享优质内容',
  description: '果冻传媒在线观看官方入口，汇聚全系列高清视频内容。无需下载即可流畅播放，海量短剧与影视持续更新。',
  copyright: `© ${new Date().getFullYear()} 果冻传媒 版权所有`,
  email: 'contact@guodongmedia.com',
  phone: '400-888-6666',
  address: '北京市朝阳区传媒文化产业园A座',
  socialLinks: [
    { name: '微博', url: '#', icon: 'ri-weibo-line' },
    { name: '微信', url: '#', icon: 'ri-wechat-line' },
    { name: '抖音', url: '#', icon: 'ri-tiktok-line' },
    { name: 'B站', url: '#', icon: 'ri-bilibili-line' },
  ],
};

export const aboutInfo = {
  brandIntro: {
    title: '关于果冻传媒',
    paragraphs: [
      '果冻传媒成立于2020年，是一家专注于优质视频内容制作与分发的综合型传媒平台。我们致力于为全球华语用户提供高品质、多元化的视频娱乐内容，涵盖短剧、电影、综艺、动漫、纪录片、音乐等多个领域。',
      '秉承"内容为王，用户至上"的理念，果冻传媒汇聚了行业内顶尖的创作团队和制作资源，持续产出深受观众喜爱的原创内容。我们的内容覆盖手机、平板、电脑等多终端，让用户随时随地享受高清流畅的观看体验。',
      '截至目前，果冻传媒已累计服务超过5000万用户，平台日均播放量突破2亿次，在行业内建立了良好的口碑和品牌影响力。',
    ],
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20media%20company%20office%20with%20creative%20team%20collaborating%2C%20warm%20lighting%2C%20contemporary%20design%2C%20professional%20atmosphere%2C%20clean%20and%20bright%20workspace&width=800&height=500&seq=about-brand-01&orientation=landscape',
  },
  milestones: [
    { year: '2020', title: '品牌创立', description: '果冻传媒在北京正式成立，首批上线100部原创短剧。' },
    { year: '2021', title: '快速发展', description: '用户突破1000万，内容库扩充至500+部作品。' },
    { year: '2022', title: '多元拓展', description: '新增电影、综艺、纪录片频道，合作导演超200位。' },
    { year: '2023', title: '技术升级', description: '全面升级4K高清播放技术，推出AI智能推荐系统。' },
    { year: '2024', title: '生态布局', description: '建立自有内容创作基地，签约艺人超100位，月活用户突破3000万。' },
    { year: '2025', title: '全球拓展', description: '内容覆盖全球20+国家和地区，上线多语言字幕，国际用户快速增长。' },
    { year: '2026', title: '行业领先', description: '日均播放量突破2亿，累计用户超5000万，稳居行业第一梯队。' },
  ],
  testimonials: [
    {
      name: '张伟',
      role: '资深影评人',
      content: '果冻传媒的原创短剧质量令人惊喜，无论是剧本深度还是制作水准都在不断提升，已经成为我日常追剧的首选平台。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20middle-aged%20man%20in%20glasses%2C%20intellectual%20look%2C%20studio%20lighting%2C%20simple%20background&width=100&height=100&seq=testimonial-01&orientation=squarish',
    },
    {
      name: '李婷',
      role: '忠实用户·追剧达人',
      content: '用果冻传媒快三年了，内容更新速度超快，画质清晰流畅。最喜欢他们的分类功能，找片很方便，推荐给身边好多朋友了！',
      avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20female%20portrait%2C%20friendly%20smile%2C%20casual%20look%2C%20natural%20lighting%2C%20simple%20warm%20background&width=100&height=100&seq=testimonial-02&orientation=squarish',
    },
    {
      name: '王磊',
      role: '影视行业从业者',
      content: '作为同行，我十分认可果冻传媒对内容品质的追求。他们的制作团队非常专业，为整个行业树立了很好的标杆。',
      avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%2C%20creative%20industry%20professional%2C%20confident%20expression%2C%20modern%20casual%20style%2C%20studio%20lighting&width=100&height=100&seq=testimonial-03&orientation=squarish',
    },
  ],
};

export const faqData = [
  {
    question: '果冻传媒是否需要付费观看？',
    answer: '果冻传媒目前全系列内容均为免费观看，无需任何付费。我们通过广告模式维持运营，为用户提供免费的优质内容服务。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '果冻传媒支持手机（iOS/Android）、平板、电脑（Windows/Mac）等多终端观看，只需浏览器即可，无需下载任何客户端。',
  },
  {
    question: '视频画质如何？',
    answer: '我们提供从标清到4K超高清的多种画质选择，系统会根据您的网络状况自动推荐最佳画质，您也可以手动切换。',
  },
  {
    question: '内容更新频率是怎样的？',
    answer: '我们保持每日更新，新内容每天上午10点和晚上8点准时上线。热门剧集每周固定更新2-3集。',
  },
  {
    question: '如何联系客服？',
    answer: '您可以通过页面底部的联系方式与我们取得联系，或发送邮件至 contact@guodongmedia.com，我们的客服团队将在24小时内回复。',
  },
];